import { useState } from "react";

export const usePaperSubmissionState = () => {
  const [abstractStepNumber, setAbstractStepNumber] = useState(0);
  const [abstractConfig, setAbstractConfig] = useState(null);
  const [paperFile, setPaperFile] = useState(null);
  const [paperFileError, setPaperFileError] = useState("");
  const [abstractText, setAbstractText] = useState("");
  const [paperTitle, setPaperTitle] = useState("");
  const [selectedTrack, setSelectedTrack] = useState("");
  const [presentationMode, setPresentationMode] = useState("");
  const [submissionMethod, setSubmissionMethod] = useState("");
  const [abstractWordCount, setAbstractWordCount] = useState(0);
  const [tracks, setTracks] = useState([]);
  const [maxAbstractChars, setMaxAbstractChars] = useState(1000);
  const [maxFileSizeMb, setMaxFileSizeMb] = useState(10);
  const [wantsToSubmitAbstract, setWantsToSubmitAbstract] = useState(null);
  const [isPaperLocked, setIsPaperLocked] = useState(false);
  const [paperFileUploaded, setPaperFileUploaded] = useState(false);
  const [paperFileName, setPaperFileName] = useState("");
  const [submittedPapers, setSubmittedPapers] = useState([]);
  const [existingPaperId, setExistingPaperId] = useState(null);
  const [hasPaperSubmitted, setHasPaperSubmitted] = useState(false);
  const [paperApprovalStatus, setPaperApprovalStatus] = useState(null);
  const [paperSubmissionAction, setPaperSubmissionAction] = useState(null);
  const [showPaperSubmissionSummary, setShowPaperSubmissionSummary] =
    useState(false);

  const selectedTrackName = (() => {
    if (!selectedTrack) return "";
    const matchedTrack = tracks.find(
      (track) => String(track.id) === String(selectedTrack)
    );
    return matchedTrack?.name || selectedTrack;
  })();

  const handleUploadedPaperFileDelete = () => {
    setPaperFileUploaded(false);
    setPaperFileName("");
    setPaperFile(null);
  };

  const handleSelectedPaperFileRemove = () => {
    setPaperFile(null);
  };

  const handleInlineAbstractTextChange = (text) => {
    console.log("Textarea change - length:", text.length, "max:", maxAbstractChars);
    setAbstractText(text);
  };

  const resetPaperFormForNewSubmission = () => {
    setExistingPaperId(null);
    setPaperTitle("");
    setSelectedTrack("");
    setPresentationMode("");
    setSubmissionMethod("");
    setAbstractText("");
    setPaperFile(null);
    setPaperFileError("");
    setPaperFileUploaded(false);
    setPaperFileName("");
    setPaperApprovalStatus(null);
    setIsPaperLocked(false);
  };

  return {
    abstractStepNumber,
    setAbstractStepNumber,
    abstractConfig,
    setAbstractConfig,
    paperFile,
    setPaperFile,
    paperFileError,
    setPaperFileError,
    abstractText,
    setAbstractText,
    paperTitle,
    setPaperTitle,
    selectedTrack,
    setSelectedTrack,
    selectedTrackName,
    presentationMode,
    setPresentationMode,
    submissionMethod,
    setSubmissionMethod,
    abstractWordCount,
    setAbstractWordCount,
    tracks,
    setTracks,
    maxAbstractChars,
    setMaxAbstractChars,
    maxFileSizeMb,
    setMaxFileSizeMb,
    wantsToSubmitAbstract,
    setWantsToSubmitAbstract,
    isPaperLocked,
    setIsPaperLocked,
    paperFileUploaded,
    setPaperFileUploaded,
    paperFileName,
    setPaperFileName,
    submittedPapers,
    setSubmittedPapers,
    existingPaperId,
    setExistingPaperId,
    hasPaperSubmitted,
    setHasPaperSubmitted,
    paperApprovalStatus,
    setPaperApprovalStatus,
    paperSubmissionAction,
    setPaperSubmissionAction,
    showPaperSubmissionSummary,
    setShowPaperSubmissionSummary,
    handleUploadedPaperFileDelete,
    handleSelectedPaperFileRemove,
    handleInlineAbstractTextChange,
    resetPaperFormForNewSubmission,
  };
};
